// import PartQuoting from "./forms/PartQuoting";
import {
  PartDetailsHistory,
  PartDetailsOrders,
  PartWorkOrderPreview,
} from "../../containers";
import PartRouting from "./forms/PartRouting";

export const tabs = [
  {
    id: "ROUTING",
    icon: "Settings",
    label: "Routing",
  },
  {
    id: "DOCUMENTS",
    icon: "FileText",
    label: "Documents",
  },
  {
    id: "PREVIEW",
    icon: "Eye",
    label: "Preview",
  },
  {
    id: "ORDERS",
    icon: "Layout",
    label: "Orders",
  },
  {
    id: "HISTORY",
    icon: "Clock",
    label: "History",
  },
];

export const PART_SECTIONS = {
  ROUTING: PartRouting,
  DOCUMENTS: () => <></>,
  PREVIEW: PartWorkOrderPreview,
  ORDERS: PartDetailsOrders,
  HISTORY: PartDetailsHistory,
};

export const UpdateMapper = (formData, id) => {
  const details = formData?.details;
  const highlightedFields = formData?.highlightedFields || [];

  return {
    id,
    details: {
      partName: details?.partName,
      partNumber: details?.partNumber,
      weight: details?.weight,
      lastSentPrice: details?.lastSentPrice,
      quoteId: details?.quoteId ?? null,
      status: details?.status,
      customerIds: details?.customerIds?.map(({ id }) => id),
      managerId: details?.managerId,
      status: details?.status,
      materialId: details?.materialId,
      treeId: details?.treeId,
      partsPerTree: details?.partsPerTree,
    },
    highlightedFields: highlightedFields?.map(({ id, fieldKey, comment }) => ({
      ...(id && { id }),
      fieldKey,
      comment,
    })),
    instructions: formData?.instructions?.map(({ updatedAt, ...ins }) => ({
      ...ins,
      routing: ins?.routing.map((r, idx) => ({ ...r, order: idx })),
    })),
    locationId: formData?.locationId,
  };
};
